const Warning = (props) => (
  <svg
    width="12"
    height="12"
    viewBox="0 0 12 12"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M6 12C9.31371 12 12 9.31371 12 6C12 2.68629 9.31371 0 6 0C2.68629 0 0 2.68629 0 6C0 9.31371 2.68629 12 6 12ZM6.63251 6.87974C6.62338 7.21928 6.34549 7.48978 6.00583 7.48978C5.66631 7.48978 5.38849 7.21949 5.37916 6.88009L5.27259 3.00251C5.26127 2.59029 5.59235 2.24998 6.00472 2.24998C6.41694 2.24998 6.74795 2.59003 6.73686 3.00209L6.63251 6.87974ZM5.25 9.00859C5.25 8.79019 5.31703 8.60916 5.45109 8.46548C5.58515 8.3218 5.76812 8.24997 6 8.24997C6.23189 8.24997 6.41485 8.3218 6.54891 8.46548C6.68297 8.60916 6.75 8.79019 6.75 9.00859C6.75 9.21932 6.68478 9.39556 6.55435 9.53732C6.42391 9.67908 6.23913 9.74997 6 9.74997C5.76087 9.74997 5.57609 9.67908 5.44565 9.53732C5.31522 9.39556 5.25 9.21932 5.25 9.00859Z"
      fill="#676767"
    />
  </svg>
);

export default Warning;
